import { cloneDeep } from 'lodash';

const state = {
  list: []
};

const getters = {
  list(state) {
    return state.list || [];
  }
};

const mutations = {
  SET_LIST(state, list) {
    state.list = list;
  },
  SET_ATTRIBUTE(state, item) {
    const index = state.list.findIndex((x) => x.id === item.id);
    if (index >= 0) {
      this._vm.$set(state.list, index, cloneDeep(item));
    } else {
      state.list.push(cloneDeep(item));
    }
  }

};

const actions = {
  async getList({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$api
        .get('attributes/getList')
        .then((response) => {
          commit('SET_LIST', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  async save({ commit }, item) {
    return new Promise((resolve, reject) => {
      this._vm.$api
        .post('attributes/save', item)
        .then((response) => {
          commit('SET_ATTRIBUTE', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
